module.exports = __webpack_public_path__ + "static/media/blender.8121cfaa.svg";